import { axios } from '$app-web/api/axios';
import { DataSourceResponse } from '$app-web/types';

import { Endpoints } from '../constant';

export async function fetchStudyDataSources(studyId: number) {
    try {
        const params = { study_id: studyId };
        const { data, status } = await axios.get<Array<DataSourceResponse>>(`${Endpoints.DataSource.Root}`, { params });

        if (status === 200) {
            return data;
        } else {
            return [];
        }
    } catch {
        return [];
    }
}
